(() => {
  const ROOT = '.box__product-content .io-0002-slide.other-models .io-0002-slide-content';

  const mount = (contentEl) => {
    if (contentEl.querySelector('.sh-om-swiper')) return;

    const itemsRoot = contentEl.querySelector('.io-0002-slide-items');
    const prevBtn = contentEl.querySelector('.io-0002-slide-btn.prev');
    const nextBtn = contentEl.querySelector('.io-0002-slide-btn.next');
    if (!itemsRoot || !prevBtn || !nextBtn) return;

    const links = Array.from(itemsRoot.querySelectorAll('a.io-0002-product'));
    if (!links.length) return;

    prevBtn.type = 'button';
    nextBtn.type = 'button';
    prevBtn.classList.add('sh-om-swiper__nav', 'sh-om-swiper__nav--prev');
    nextBtn.classList.add('sh-om-swiper__nav', 'sh-om-swiper__nav--next');

    const swiperEl = document.createElement('div');
    swiperEl.className = 'swiper sh-om-swiper';
    const wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';

    links.forEach((link) => {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide sh-om-swiper__slide';
      slide.appendChild(link);
      wrapper.appendChild(slide);
    });

    swiperEl.appendChild(wrapper);
    swiperEl.appendChild(prevBtn);
    swiperEl.appendChild(nextBtn);

    itemsRoot.remove();
    contentEl.appendChild(swiperEl);

    const slideCount = links.length;

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 6,
      watchOverflow: true,
      navigation:
        slideCount > 1
          ? {
              prevEl: prevBtn,
              nextEl: nextBtn,
            }
          : false,
      breakpoints: {
        480: {
          spaceBetween: 8,
        },
        750: {
          spaceBetween: 12,
        },
      },
    });

    const syncNavVisibility = () => {
      // Hide both arrows when slider cannot move in either direction.
      const shouldHide = swiper.isLocked || (swiper.isBeginning && swiper.isEnd);
      prevBtn.classList.toggle('is-hidden', shouldHide);
      nextBtn.classList.toggle('is-hidden', shouldHide);
    };

    syncNavVisibility();
    swiper.on('init', syncNavVisibility);
    swiper.on('resize', syncNavVisibility);
    swiper.on('breakpoint', syncNavVisibility);
    swiper.on('update', syncNavVisibility);
    swiper.on('observerUpdate', syncNavVisibility);
    swiper.on('lock', syncNavVisibility);
    swiper.on('unlock', syncNavVisibility);
    swiper.on('slidesLengthChange', syncNavVisibility);
  };

  const initInRoot = (root) => {
    if (typeof Swiper === 'undefined') return;
    root.querySelectorAll(ROOT).forEach(mount);
  };

  const boot = () => {
    if (typeof Swiper === 'undefined') {
      setTimeout(boot, 50);
      return;
    }
    initInRoot(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (ev) => {
    if (!ev.target || !ev.target.querySelector) return;
    initInRoot(ev.target);
  });
})();
